export default "__VITE_ASSET__B842x7$1__"